/**
 * Resolve image paths from API (relative or absolute URLs).
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    return trimmed;
  }
  return `/${trimmed}`;
}

/** Card photo: featured_image, or images/<service name>.png in the images folder. */
export function getServiceCardImage(service) {
  if (!service) return null;
  const stored = resolveMediaUrl(service.featured_image);
  if (stored) return stored;
  const name = service.service_name || service.title;
  if (!name) return null;
  return `/images/${encodeURIComponent(name)}.png`;
}
